<template>
  <validation-observer v-slot="{ invalid }" ref="observer" tag="div">
    <form class="form-horizontal form-register" @submit.prevent="submit">
      <overlay-progress-circular
        :value="submitting"
        color="#E3F2FD"
        :size="78"
        :width="6"
      />

      <input-field
        :fieldId="String(inputDecorated.id)"
        :key="inputDecorated.id"
        :name="inputDecorated.name"
        :description="inputDecorated.description"
        :tooltip="inputDecorated.tooltip"
        :required="true"
        :enabled="inputDecorated.enabled"
        :pattern="inputDecorated.regexp"
        v-model="data[inputDecorated.keyFormulaire]"
        :type="inputDecorated.type"
      ></input-field>

      <div class="alert alert-danger" v-if="submitError">{{ submitError }}</div>
      <div class="buttons">
        <a :href="$appSettings.CancelUrl">{{ $texts.cancelButton }}</a>
        <button
          :disabled="invalid || submitting"
          type="submit"
          class="btn btn-secondary"
        >
          {{ $texts.validateButton }}
        </button>
      </div>
    </form>
  </validation-observer>
</template>

<script>
import Vue from "vue";
import { ValidationObserver } from "vee-validate";
import { FormRequest } from "../../models/requests/FormRequest";
import InputField from "../fields/InputField.vue";
import { UserService } from "@/InscriptionFlow/services/UserService";
import { getWebApiErrorMessage } from "@/Commons/ErrorHelper";
import OverlayProgressCircular from "@/Commons/components/OverlayProgressCircular.vue";
import { getModule } from "vuex-module-decorators";
import { AccountDetectionModeModule } from "@/InscriptionFlowsAdmin/store/modules/AccountDetectionModeModule";
import { AccountDetectionModes } from "@/InscriptionFlow/models/enums/AccountDetectionModes";

export default Vue.extend({
  name: "association-mail-search",

  components: {
    ValidationObserver,
    InputField,
    OverlayProgressCircular
  },

  props: {
    inputData: {
      type: Object,
      required: true
    },
    linking: {
      type: Boolean,
      required: true
    },
    authenticateBy: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      data: new FormRequest(),
      submitError: null,
      accountDetectionModes: getModule(AccountDetectionModeModule),
      submitting: false
    };
  },

  computed: {
    inputDecorated() {
      return {
        ...this.inputData,
        keyFormulaire:
          this.authenticateBy === AccountDetectionModes.Email
            ? "email"
            : "nationalId",
        type:
          this.authenticateBy === AccountDetectionModes.Email ? "email" : "text"
      };
    }
  },

  methods: {
    async submit() {
      this.submitError = null;
      this.submitting = true;
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }

      const existsPromise =
        this.authenticateBy === AccountDetectionModes.Email
          ? UserService.existsByEmail(this.data.email)
          : UserService.existsByNationalId(this.data.nationalId);

      existsPromise
        .then(result => {
          if (result) {
            this.$router.push({
              name: "association",
              params: {
                email: this.data.email,
                nationalId: this.data.nationalId,
                linking: this.linking
              }
            });
          } else if (!this.linking) {
            this.$router.push({
              name: "inscription-flow-register",
              params: {
                email: this.data.email,
                nationalId: this.data.nationalId
              }
            });
          } else {
            this.$router.push({
              name: "form-cps-register",
              params: {
                email: this.data.email,
                nationalId: this.data.nationalId
              }
            });
          }
        })
        .catch(error => {
          this.submitError = getWebApiErrorMessage(error);
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },

  watch: {}
});
</script>

<style scoped>
.buttons {
  display: flex;
  justify-content: space-evenly;
}
.form-register {
  margin-bottom: 15px;
}
</style>
